import React from 'react';
import { GovIcon, GovMessage } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { LayoutGap } from '@gov-nx/ui/web';
import { MarkdownRender } from '../../../Markdown/MarkdownRender';

interface ApplicantPOProps {
	code: PageCode;
}

export const ApplicantPO = ({ code }: ApplicantPOProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<LayoutGap
			gap="m"
			className="mt-4">
			<GovMessage
				color="warning"
				type="subtle"
				icon={
					<GovIcon
						type="components"
						name="info-circle-fill"
					/>
				}>
				<MarkdownRender>{tsn('formular.zprava.varovani-po')}</MarkdownRender>
			</GovMessage>
		</LayoutGap>
	);
};
